import React, { Component, Fragment } from 'react'
import { Query, withApollo } from 'react-apollo'
import gql from 'graphql-tag'
import Grid from '@material-ui/core/Grid'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import CardActions from '@material-ui/core/CardActions'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import Divider from '@material-ui/core/Divider'
import { DatePicker } from 'material-ui-pickers'
import moment from 'moment'

const styles = theme => ({
  rowStyle: {
    margin: '15px 0'
  },
  textFieldStyle: {
    width: '55%'
  },
  dateStyle: {
    width: '50%'
  },
  subHeadingStyle: {
    marginLeft: '1.9vw',
    marginBottom: '10px',
    fontSize: '1rem',
    fontWeight: 'bold'
  },
  cardAction: {
    marginLeft: '-1.9vw'
  }
})

class BillingDetailsProformaInvoice extends Component {
  render() {
    const { classes, piInfoData } = this.props
    const { billingDetails } = piInfoData
    const {
      paymentStatus,
      hardwarePaymentMade,
      softwarePaymentMade,
      accessoryPaymentMade,
      simPaymentMade,
      hardwareBalance,
      softwareBalance,
      accessoryBalance,
      simBalance,
      hardwareRemarks,
      softwareRemarks,
      accessoryRemarks,
      simRemarks,
      expectedHardwareDueDate,
      expectedSoftwareDueDate,
      expectedAccessoryDueDate,
      expectedSimsDueDate,
      handlePaymentMade,
      handleRemarksChange,
      handleExpectedDateChange
    } = this.props

    return (
      <Fragment>
        {billingDetails && (
          <Card raised>
            <CardContent>
              <CardHeader
                className={classes.cardAction}
                title="Billing Details"
              />
              {/* Billing Details Body */}
              <Grid container justify="space-between">
                {/* Column Header Section  */}
                <Grid item style={{ marginRight: '7vw' }}>
                  <Grid
                    container
                    direction="column"
                    alignContent="space-between"
                  >
                    <Grid item className={classes.rowStyle}>
                      <Typography variant="body2">PARTICULARS</Typography>
                    </Grid>
                    <Grid item className={classes.rowStyle}>
                      <Typography variant="body2"> Quantity</Typography>
                    </Grid>
                    <Grid item className={classes.rowStyle}>
                      <Typography variant="body2">
                        {' '}
                        Total Bill(Incl. GST)
                      </Typography>
                    </Grid>
                    <Grid item className={classes.rowStyle}>
                      <Typography variant="body2"> Total Paid</Typography>
                    </Grid>
                    <Grid item className={classes.rowStyle}>
                      <Typography variant="body2"> Total Payable</Typography>
                    </Grid>
                    <Grid item className={classes.rowStyle}>
                      <Typography variant="body2"> Payment Made</Typography>
                    </Grid>
                  </Grid>
                </Grid>

                {/*  Hardware Column Data */}
                {billingDetails.hardwareBillDetails && (
                  <Grid item>
                    <Grid
                      container
                      direction="column"
                      alignContent="space-between"
                    >
                      <Grid item className={classes.rowStyle}>
                        <Typography variant="body2"> HARDWARE</Typography>
                      </Grid>
                      <Grid item className={classes.rowStyle}>
                        <Typography variant="body1">
                          {billingDetails.hardwareBillDetails.quantity}
                        </Typography>
                      </Grid>
                      <Grid item className={classes.rowStyle}>
                        <Typography variant="body1">
                          &#8377; {billingDetails.hardwareBillDetails.amountGST}
                        </Typography>
                      </Grid>
                      <Grid item className={classes.rowStyle}>
                        <Typography variant="body1">
                          &#8377;{' '}
                          {billingDetails.hardwareBillDetails.amountPaidGST}
                        </Typography>
                      </Grid>
                      <Grid item className={classes.rowStyle}>
                        <Typography variant="body1">
                          &#8377;{' '}
                          {billingDetails.hardwareBillDetails.amountToBePaidGST}
                        </Typography>
                      </Grid>
                      <Grid item className={classes.rowStyle}>
                        &#8377;{' '}
                        <TextField
                          type="Number"
                          className={classes.textFieldStyle}
                          label="Paid Amount *"
                          inputProps={{ min: 0 }}
                          value={hardwarePaymentMade}
                          onChange={handlePaymentMade('hardwarePaymentMade')}
                          margin="none"
                          disabled={
                            billingDetails.hardwareBillDetails
                              .amountToBePaidGST <= 0
                          }
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                )}

                {/*  Software Column Data */}
                {billingDetails.softwareBillDetails && (
                  <Grid item>
                    <Grid
                      container
                      direction="column"
                      alignContent="space-between"
                    >
                      <Grid item className={classes.rowStyle}>
                        <Typography variant="body2"> SOFTWARE </Typography>
                      </Grid>
                      <Grid item className={classes.rowStyle}>
                        <Typography variant="body1">
                          {billingDetails.softwareBillDetails.quantity}
                        </Typography>
                      </Grid>
                      <Grid item className={classes.rowStyle}>
                        <Typography variant="body1">
                          &#8377; {billingDetails.softwareBillDetails.amountGST}
                        </Typography>
                      </Grid>
                      <Grid item className={classes.rowStyle}>
                        <Typography variant="body1">
                          &#8377;{' '}
                          {billingDetails.softwareBillDetails.amountPaidGST}
                        </Typography>
                      </Grid>
                      <Grid item className={classes.rowStyle}>
                        <Typography variant="body1">
                          &#8377;{' '}
                          {billingDetails.softwareBillDetails.amountToBePaidGST}
                        </Typography>
                      </Grid>
                      <Grid item className={classes.rowStyle}>
                        &#8377;{' '}
                        <TextField
                          type="Number"
                          className={classes.textFieldStyle}
                          label="Paid Amount *"
                          inputProps={{ min: 0 }}
                          value={softwarePaymentMade}
                          onChange={handlePaymentMade('softwarePaymentMade')}
                          margin="none"
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                )}

                {/*  Accessory Column Data */}
                {billingDetails.accessoryBillDetails && (
                  <Grid item>
                    <Grid
                      container
                      direction="column"
                      alignContent="space-between"
                    >
                      <Grid item className={classes.rowStyle}>
                        <Typography variant="body2"> ACCESSORY</Typography>
                      </Grid>
                      <Grid item className={classes.rowStyle}>
                        <Typography variant="body1">
                          {' '}
                          {billingDetails.accessoryBillDetails.quantity}
                        </Typography>
                      </Grid>
                      {/* <Grid item className={classes.rowStyle}>
                        <Typography variant="body1">
                          {' '}
                          {billingDetails.accessoryBill.rate}
                        </Typography>
                      </Grid> */}
                      <Grid item className={classes.rowStyle}>
                        <Typography variant="body1">
                          &#8377;{' '}
                          {billingDetails.accessoryBillDetails.amountGST}
                        </Typography>
                      </Grid>
                      <Grid item className={classes.rowStyle}>
                        &#8377;{' '}
                        <Typography variant="body1">
                          {billingDetails.accessoryBillDetails.amountPaidGST}
                        </Typography>
                      </Grid>
                      <Grid item className={classes.rowStyle}>
                        <Typography variant="body1">
                          &#8377;{' '}
                          {
                            billingDetails.accessoryBillDetails
                              .amountToBePaidGST
                          }
                        </Typography>
                      </Grid>
                      <Grid item className={classes.rowStyle}>
                        &#8377;{' '}
                        <TextField
                          type="Number"
                          className={classes.textFieldStyle}
                          label="Paid Amount *"
                          inputProps={{ min: 0 }}
                          value={accessoryPaymentMade}
                          onChange={handlePaymentMade('accessoryPaymentMade')}
                          margin="none"
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                )}

                {/*  Sims Column Data */}
                {billingDetails.simBillDetails && (
                  <Grid item>
                    <Grid
                      container
                      direction="column"
                      alignContent="space-between"
                    >
                      <Grid item className={classes.rowStyle}>
                        <Typography variant="body2"> SIM </Typography>
                      </Grid>
                      <Grid item className={classes.rowStyle}>
                        <Typography variant="body1">
                          {billingDetails.simBillDetails.quantity}
                        </Typography>
                      </Grid>
                      <Grid item className={classes.rowStyle}>
                        <Typography variant="body1">
                          &#8377; {billingDetails.simBillDetails.amountGST}
                        </Typography>
                      </Grid>
                      <Grid item className={classes.rowStyle}>
                        <Typography variant="body1">
                          &#8377; {billingDetails.simBillDetails.amountPaidGST}
                        </Typography>
                      </Grid>
                      <Grid item className={classes.rowStyle}>
                        <Typography variant="body1">
                          &#8377;{' '}
                          {billingDetails.simBillDetails.amountToBePaidGST}
                        </Typography>
                      </Grid>
                      <Grid item className={classes.rowStyle}>
                        &#8377;{' '}
                        <TextField
                          type="Number"
                          className={classes.textFieldStyle}
                          label="Paid Amount *"
                          inputProps={{ min: 0 }}
                          value={simPaymentMade}
                          onChange={handlePaymentMade('simPaymentMade')}
                          margin="none"
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                )}
              </Grid>
            </CardContent>
          </Card>
        )}
        <br />

        {billingDetails && (
          <Card raised>
            <CardContent>
              <CardHeader className={classes.cardAction} title="Credit Note" />

              {/* Credit Note Section */}
              <Grid container justify="space-between">
                {/* Column Header Section  */}
                <Grid item style={{ marginRight: '7vw' }}>
                  <Grid
                    container
                    direction="column"
                    alignContent="space-between"
                  >
                    <Grid item className={classes.rowStyle}>
                      <Typography variant="body2">Balance</Typography>
                    </Grid>
                    <Grid item className={classes.rowStyle}>
                      <Typography variant="body2">Credit Date</Typography>
                    </Grid>
                    {[0].includes(paymentStatus) && (
                      <Grid item style={{ margin: '25px 0' }}>
                        <Typography variant="body2">
                          {' '}
                          Expected Due Date
                        </Typography>
                      </Grid>
                    )}
                    {/* <Grid item style={{ margin: '40px 0', display: 'none' }}>
                      <Typography variant="body2"> Remarks</Typography>
                    </Grid> */}
                  </Grid>
                </Grid>

                {/*  Hardware Column Data */}
                {billingDetails.hardwareBillDetails && (
                  <Grid item disabled>
                    <Grid
                      container
                      direction="column"
                      alignContent="space-between"
                    >
                      <Grid item className={classes.rowStyle}>
                        <Typography variant="body2">
                          &#8377; {hardwareBalance}
                        </Typography>
                      </Grid>
                      <Grid item className={classes.rowStyle}>
                        <Typography
                          variant="body2"
                          style={{
                            marginRight: '100px'
                          }}
                        >
                          {moment
                            .unix(
                              parseInt(
                                piInfoData.billingDetails.hardwareBillDetails
                                  .creditDate,
                                10
                              )
                            )
                            .format('DD/MM/YYYY')}
                        </Typography>
                      </Grid>
                      {[0].includes(paymentStatus) && (
                        <Grid item className={classes.rowStyle}>
                          <DatePicker
                            disabled={hardwareBalance === 0}
                            className={classes.dateStyle}
                            label="Due Date"
                            value={expectedHardwareDueDate}
                            // views={['year', 'month', 'date']}
                            format="DD/MM/YYYY"
                            onChange={handleExpectedDateChange(
                              'expectedHardwareDueDate'
                            )}
                          />
                        </Grid>
                      )}
                      {/* <Grid item className={classes.rowStyle}>
                        <TextField
                          disabled={hardwareBalance === 0}
                          className={classes.textFieldStyle}
                          label=" Remarks"
                          multiline
                          value={hardwareRemarks}
                          onChange={handleRemarksChange('hardwareRemarks')}
                          margin="none"
                        />
                      </Grid> */}
                    </Grid>
                  </Grid>
                )}

                {/*  Software Column Data */}
                {billingDetails.softwareBillDetails && (
                  <Grid item>
                    <Grid
                      container
                      direction="column"
                      alignContent="space-between"
                    >
                      <Grid item className={classes.rowStyle}>
                        <Typography variant="body2">
                          &#8377; {softwareBalance}
                        </Typography>
                      </Grid>
                      <Grid item className={classes.rowStyle}>
                        <Typography
                          variant="body2"
                          style={{
                            marginRight: '100px'
                          }}
                        >
                          {moment
                            .unix(
                              parseInt(
                                piInfoData.billingDetails.softwareBillDetails
                                  .creditDate,
                                10
                              )
                            )
                            .format('DD/MM/YYYY')}
                        </Typography>
                      </Grid>
                      {[0].includes(paymentStatus) && (
                        <Grid item className={classes.rowStyle}>
                          <DatePicker
                            disabled={softwareBalance === 0}
                            className={classes.dateStyle}
                            label="Due Date"
                            value={expectedSoftwareDueDate}
                            onChange={handleExpectedDateChange(
                              'expectedSoftwareDueDate'
                            )}
                            format="DD/MM/YYYY"
                          />
                        </Grid>
                      )}
                      {/* <Grid item className={classes.rowStyle}>
                        <TextField
                          disabled={softwareBalance === 0}
                          className={classes.textFieldStyle}
                          label=" Remarks "
                          multiline
                          value={softwareRemarks}
                          onChange={handleRemarksChange('softwareRemarks')}
                          margin="none"
                        />
                      </Grid> */}
                    </Grid>
                  </Grid>
                )}

                {/*  Accessory Column Data */}
                {billingDetails.accessoryBillDetails && (
                  <Grid item>
                    <Grid
                      container
                      direction="column"
                      alignContent="space-between"
                    >
                      <Grid item className={classes.rowStyle}>
                        <Typography variant="body2">
                          &#8377; {accessoryBalance}
                        </Typography>
                      </Grid>
                      <Grid item className={classes.rowStyle}>
                        <Typography
                          variant="body2"
                          style={{
                            marginRight: '100px'
                          }}
                        >
                          {moment
                            .unix(
                              parseInt(
                                piInfoData.billingDetails.accessoryBillDetails
                                  .creditDate,
                                10
                              )
                            )
                            .format('DD/MM/YYYY')}
                        </Typography>
                      </Grid>
                      {[0].includes(paymentStatus) && (
                        <Grid item className={classes.rowStyle}>
                          <DatePicker
                            disabled={accessoryBalance === 0}
                            className={classes.dateStyle}
                            label="Due Date"
                            value={expectedAccessoryDueDate}
                            onChange={handleExpectedDateChange(
                              'expectedAccessoryDueDate'
                            )}
                            format="DD/MM/YYYY"
                          />
                        </Grid>
                      )}
                      {/* <Grid item className={classes.rowStyle}>
                        <TextField
                          disabled={accessoryBalance === 0}
                          className={classes.textFieldStyle}
                          label=" Remarks "
                          multiline
                          value={accessoryRemarks}
                          onChange={handleRemarksChange('accessoryRemarks')}
                          margin="none"
                        />
                      </Grid> */}
                    </Grid>
                  </Grid>
                )}

                {/*  Sims Column Data */}
                {billingDetails.simBillDetails ? (
                  <Grid item>
                    <Grid
                      container
                      direction="column"
                      alignContent="space-between"
                    >
                      <Grid item className={classes.rowStyle}>
                        <Typography variant="body2">
                          &#8377; {simBalance}
                        </Typography>
                      </Grid>
                      <Grid item className={classes.rowStyle}>
                        <Typography
                          variant="body2"
                          style={{
                            marginRight: '100px'
                          }}
                        >
                          {moment
                            .unix(
                              parseInt(
                                piInfoData.billingDetails.simBillDetails
                                  .creditDate,
                                10
                              )
                            )
                            .format('DD/MM/YYYY')}
                        </Typography>
                      </Grid>
                      {[0].includes(paymentStatus) && (
                        <Grid item className={classes.rowStyle}>
                          <DatePicker
                            disabled={simBalance === 0}
                            className={classes.dateStyle}
                            label="Due Date"
                            value={expectedSimsDueDate}
                            onChange={handleExpectedDateChange(
                              'expectedSimsDueDate'
                            )}
                            format="DD/MM/YYYY"
                          />
                        </Grid>
                      )}
                      {/* <Grid item className={classes.rowStyle}>
                        <TextField
                          disabled={simBalance === 0}
                          className={classes.textFieldStyle}
                          label=" Remarks"
                          multiline
                          value={simRemarks}
                          onChange={handleRemarksChange('simRemarks')}
                          margin="none"
                        />
                      </Grid> */}
                    </Grid>
                  </Grid>
                ) : null}
              </Grid>
            </CardContent>
          </Card>
        )}
      </Fragment>
    )
  }
}

export default withStyles(styles)(withApollo(BillingDetailsProformaInvoice))



// WEBPACK FOOTER //
// ./src/components/Pages/Billing/CreateProformaInvoice/BillingDetailsProformaInvoice.jsx